<template>
  <div class="employeeDetail">
    <van-form label-width="80px">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1">
          <template #title>
            <div class="collapse-title">{{ $t.employee.title1 }}</div>
          </template>
          <van-field :label="$t.employee.photo">
            <template #input>
              <van-image
                class="avatarImg"
                :src="imgUrlFilter(form.PersonalPhoto)"
                @click="
                  form.PersonalPhoto
                    ? imagePreview(imgUrlFilter(form.PersonalPhoto))
                    : false
                "
              >
                <template v-slot:error>
                  <img
                    class="userImg"
                    src="~assets/img/userManage/img_logo@2x.png" /></template
              ></van-image>
            </template>
          </van-field>
          <van-field
            clickable
            :value="form.EntryDate"
            :label="$t.employee.entryDate"
            disabled
          />
          <van-field
            v-model="form.EntryPosition"
            :label="$t.employee.position"
            disabled
          />
        </van-collapse-item>
      </van-collapse>

      <van-collapse v-model="activeNames">
        <van-collapse-item name="2">
          <template #title>
            <div class="collapse-title">{{ $t.employee.title2 }}</div>
          </template>

          <van-field v-model="form.Surname" :label="$t.employee.surname" disabled />
          <van-field
            v-model="form.PhoneNumber"
            :label="$t.employee.phoneNumber"
            disabled
          />
          <van-field
            v-model="form.IdentityCardNumber"
            :label="$t.employee.idCardNumber"
            disabled
          />
          <van-field :label="$t.employee.marital">
            <template #input>
              <van-radio-group
                v-model="form.MaritalState"
                direction="horizontal"
                disabled
              >
                <van-radio :name="1">{{ $t.employee.mOption1 }}</van-radio>
                <van-radio :name="2">{{ $t.employee.mOption2 }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="form.CommunicationAddress"
            :label="$t.employee.address"
            type="textarea"
            rows="5"
            disabled
          />
          <van-field
            v-model="form.Nationality"
            :label="$t.employee.nationality"
            disabled
          />
          <van-field
            v-model="form.NativePlace"
            :label="$t.employee.nativePlace"
            disabled
          />
          <van-field :label="$t.employee.gender">
            <template #input>
              <van-radio-group v-model="form.Gender" direction="horizontal" disabled>
                <van-radio :name="1">{{ $t.employee.male }}</van-radio>
                <van-radio :name="2">{{ $t.employee.female }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            clickable
            :value="form.BirthDate"
            :label="$t.employee.birthDate"
            disabled
          />

          <div class="multi-table" v-if="form.EmergencyContactList">
            <van-field name="stepper" :label="$t.employee.title3">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.EmergencyContactList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.EmergencyContactList" :key="index">
              <div class="multi-table-header">
                <div class="multi-table-title">No. {{ index + 1 }}</div>
              </div>
              <van-field
                v-model="item.ContactName"
                :label="$t.employee.contactName"
                disabled
              />
              <van-field
                v-model="item.ContactPhoneNumber"
                :label="$t.employee.contactPhone"
                disabled
              />
            </div>
          </div>

          <div class="multi-table" v-if="form.EducationList">
            <van-field name="stepper" :label="$t.employee.title4">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.EducationList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.EducationList" :key="index">
              <div class="multi-table-header">
                <div class="multi-table-title">No. {{ index + 1 }}</div>
              </div>
              <van-field
                v-model="item.Education"
                :label="$t.employee.education"
                disabled
              />
              <van-field
                v-model="item.GraduateSchool"
                :label="$t.employee.school"
                disabled
              />
              <van-field
                clickable
                :value="item.EnrollmentDate"
                :label="$t.employee.enrollmentDate"
                disabled
              />
              <van-field
                clickable
                :value="item.GraduationDate"
                :label="$t.employee.graduationDate"
                disabled
              />
            </div>
          </div>

          <div class="multi-table" v-if="form.LanguageList">
            <van-field name="stepper" :label="$t.employee.title5">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.LanguageList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.LanguageList" :key="index">
              <div class="multi-table-header">
                <div class="multi-table-title">No. {{ index + 1 }}</div>
              </div>
              <van-field
                v-model="item.Language"
                :label="$t.employee.languageName"
                disabled
              />
              <van-field :label="$t.employee.listen">
                <template #input>
                  <van-radio-group v-model="item.Listen" direction="horizontal" disabled>
                    <van-radio :name="1">{{ $t.employee.lOption1 }}</van-radio>
                    <van-radio :name="2">{{ $t.employee.lOption2 }}</van-radio>
                    <van-radio :name="3">{{ $t.employee.lOption3 }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-field :label="$t.employee.say">
                <template #input>
                  <van-radio-group v-model="item.Say" direction="horizontal" disabled>
                    <van-radio :name="1">{{ $t.employee.lOption1 }}</van-radio>
                    <van-radio :name="2">{{ $t.employee.lOption2 }}</van-radio>
                    <van-radio :name="3">{{ $t.employee.lOption3 }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-field :label="$t.employee.read">
                <template #input>
                  <van-radio-group v-model="item.Read" direction="horizontal" disabled>
                    <van-radio :name="1">{{ $t.employee.lOption1 }}</van-radio>
                    <van-radio :name="2">{{ $t.employee.lOption2 }}</van-radio>
                    <van-radio :name="3">{{ $t.employee.lOption3 }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-field :label="$t.employee.write">
                <template #input>
                  <van-radio-group v-model="item.Write" direction="horizontal" disabled>
                    <van-radio :name="1">{{ $t.employee.lOption1 }}</van-radio>
                    <van-radio :name="2">{{ $t.employee.lOption2 }}</van-radio>
                    <van-radio :name="3">{{ $t.employee.lOption3 }}</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
          </div>

          <div class="multi-table" v-if="form.TrainingCourseInfoList">
            <van-field name="stepper" :label="$t.employee.title6">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.TrainingCourseInfoList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.TrainingCourseInfoList" :key="index">
              <div class="multi-table-header">
                <div class="multi-table-title">No. {{ index + 1 }}</div>
              </div>
              <van-field
                v-model="item.CourseName"
                :label="$t.employee.courseName"
                disabled
              />
              <van-field
                v-model="item.TrainingInstitutions"
                :label="$t.employee.institutions"
                disabled
              />
              <van-field
                clickable
                :value="item.TrainingBeginDate"
                :label="$t.employee.beginDate"
                disabled
              />
              <van-field
                clickable
                :value="item.TrainingEndDate"
                :label="$t.employee.endDate"
                disabled
              />
            </div>
          </div>

          <div class="multi-table" v-if="form.CertificateList">
            <van-field name="stepper" :label="$t.employee.title7">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.CertificateList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.CertificateList" :key="index">
              <div class="multi-table-header">
                <div class="multi-table-title">No. {{ index + 1 }}</div>
              </div>
              <van-field
                v-model="item.CertificateName"
                :label="$t.employee.certificate"
                disabled
              />
              <van-field
                clickable
                :value="item.EffectiveBeginDate"
                :label="$t.employee.cBeginDate"
                disabled
              />
              <van-field
                clickable
                :value="item.EffectiveEndDate"
                :label="$t.employee.cEndDate"
                disabled
              />
            </div>
          </div>

          <div class="multi-table" v-if="form.BankAccountList">
            <van-field name="stepper" :label="$t.employee.title8">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.BankAccountList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.BankAccountList" :key="index">
              <div class="multi-table-header">
                <div class="multi-table-title">No. {{ index + 1 }}</div>
              </div>
              <van-field
                v-model="item.PayeeName"
                :label="$t.employee.payeeName"
                disabled
              />
              <van-field v-model="item.BankName" :label="$t.employee.bankName" disabled />
              <van-field
                v-model="item.BankAccount"
                :label="$t.employee.bankAccount"
                disabled
              />
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>

      <van-collapse v-model="activeNames">
        <van-collapse-item name="3">
          <template #title>
            <div class="collapse-title">{{ $t.employee.title9 }}</div>
          </template>
          <div
            class="multi-table"
            style="margin-top: 0px"
            v-if="form.IdentificationCardFileList"
          >
            <van-field name="stepper" :label="$t.employee.idCard">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.IdentificationCardFileList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.IdentificationCardFileList" :key="index">
              <van-field :label="'No.' + (index + 1)">
                <template #input>
                  <van-image
                    :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                    @click="imagePreview(imgUrlFilter(item.FileAddress))"
                    width="50"
                    height="50"
                    fit="contain"
                    style="vertical-align: top"
                    v-if="item.FileAddress"
                  ></van-image>
                </template>
              </van-field>
            </div>
          </div>

          <div class="multi-table" v-if="form.GraduationCertificateFileList">
            <van-field name="stepper" :label="$t.employee.graduationBook">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.GraduationCertificateFileList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.GraduationCertificateFileList" :key="index">
              <van-field :label="'No.' + (index + 1)">
                <template #input>
                  <van-image
                    :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                    @click="imagePreview(imgUrlFilter(item.FileAddress))"
                    width="50"
                    height="50"
                    fit="contain"
                    style="vertical-align: top"
                    v-if="item.FileAddress"
                  ></van-image>
                </template>
              </van-field>
            </div>
          </div>

          <div class="multi-table" v-if="form.ResignationCertificateFileList">
            <van-field name="stepper" :label="$t.employee.resignBook">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.ResignationCertificateFileList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div
              v-for="(item, index) in form.ResignationCertificateFileList"
              :key="index"
            >
              <van-field :label="'No.' + (index + 1)">
                <template #input>
                  <van-image
                    :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                    @click="imagePreview(imgUrlFilter(item.FileAddress))"
                    width="50"
                    height="50"
                    fit="contain"
                    style="vertical-align: top"
                    v-if="item.FileAddress"
                  ></van-image>
                </template>
              </van-field>
            </div>
          </div>

          <div class="multi-table" v-if="form.ResumeFileList">
            <van-field name="stepper" :label="$t.employee.resume">
              <template #input>
                <van-stepper
                  :min="0"
                  :value="form.ResumeFileList.length"
                  :disabled="true"
                />
              </template>
            </van-field>
            <div v-for="(item, index) in form.ResumeFileList" :key="index">
              <van-field :label="'No.' + (index + 1)">
                <template #input>
                  <van-image
                    :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                    @click="imagePreview(imgUrlFilter(item.FileAddress))"
                    width="50"
                    height="50"
                    fit="contain"
                    style="vertical-align: top"
                    v-if="item.FileAddress"
                  ></van-image>
                </template>
              </van-field>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>

      <div class="title">{{ $t.employee.sourceTitle }}</div>
      <van-field
        v-model="contents.ReceiveServer"
        :label="$t.employee.receivingServer"
        :placeholder="$t.meta.input"
      />
      <van-field
        v-model="contents.ReceivePort"
        :label="$t.employee.receivePort"
        :placeholder="$t.meta.input"
      />
      <van-field
        v-model="contents.SendServer"
        :label="$t.employee.sendServer"
        :placeholder="$t.meta.input"
      />
      <van-field
        v-model="contents.SendPort"
        :label="$t.employee.sendPort"
        :placeholder="$t.meta.input"
      />

      <div class="multi-table" v-if="contents.ResourceAllocationList">
        <van-field name="stepper" :label="$t.employee.allocatingResource">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationList.length"
              @minus="handleResourceDel"
              @plus="handleResourceAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleResourceDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>

          <van-field
            v-model="item.AssetTypeName"
            :label="$t.employee.assetType"
            @click="pickerShow(index, 'showAssetPicker', 'ResourceAllocationList')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />

          <van-field
            v-model="item.ACName"
            :label="$t.enterpriseLogistics.class"
            @click="pickerShow(index, 'showACPicker', 'ResourceAllocationList')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />

          <van-field
            v-model="item.ProductName"
            :label="$t.enterpriseLogistics.goodsName"
            @click="pickerShow(index, 'showProductPicker', 'ResourceAllocationList')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            v-if="item.AssetType == 1"
          />

          <van-field
            v-model="item.AccountNumber"
            :label="$t.enterpriseLogistics.accountName"
            @click="pickerShow(index, 'showAccountPicker', 'ResourceAllocationList')"
            :placeholder="$t.meta.select"
            clickable
            readonly
            v-if="item.AssetType == 2"
          />

          <div class="custom-date">
            <div class="date-btn1">
              {{ $t.enterpriseLogistics.handoverDate }}
            </div>
            <div class="date-btn2" @click="showTimeDate">
              <span v-if="item.HandoverDate" class="value">{{ item.HandoverDate }}</span>
              <span v-else class="placeholder">{{ $t.meta.select }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="multi-table" v-if="contents.ResourceAllocationFileList1">
        <van-field name="stepper" :label="$t.employee.welcomeLetter">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationFileList1.length"
              @minus="handleResource1Del"
              @plus="handleResource1Add"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationFileList1" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleResource1DelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead1" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="contents.ResourceAllocationFileList2">
        <van-field name="stepper" :label="$t.employee.cardFront">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationFileList2.length"
              @minus="handleResource2Del"
              @plus="handleResource2Add"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationFileList2" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleResource2DelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead2" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="contents.ResourceAllocationFileList3">
        <van-field name="stepper" :label="$t.employee.cardBack">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationFileList3.length"
              @minus="handleResource3Del"
              @plus="handleResource3Add"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationFileList3" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleResource3DelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead3" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="contents.ResourceAllocationFileList4">
        <van-field name="stepper" :label="$t.employee.mailSignature">
          <template #input>
            <van-stepper
              :min="0"
              :value="contents.ResourceAllocationFileList4.length"
              @minus="handleResource4Del"
              @plus="handleResource4Add"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in contents.ResourceAllocationFileList4" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleResource4DelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead4" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" @click="onSubmit">{{
          $t.information.save
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showAssetPicker" round position="bottom">
      <van-picker
        :title="$t.employee.assetType"
        show-toolbar
        :columns="assetTypeOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="assetConfirm($event)"
        @cancel="showAssetPicker = false"
      />
    </van-popup>

    <van-popup v-model="showACPicker" round position="bottom">
      <van-picker
        :title="$t.enterpriseLogistics.class"
        show-toolbar
        :columns="categoryList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="acConfirm($event)"
        @cancel="showACPicker = false"
      />
    </van-popup>

    <van-popup v-model="showProductPicker" round position="bottom">
      <van-picker
        :title="$t.enterpriseLogistics.goodsName"
        show-toolbar
        :columns="categoryOptions1"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="productConfirm($event)"
        @cancel="showProductPicker = false"
      />
    </van-popup>

    <van-popup v-model="showAccountPicker" round position="bottom">
      <van-picker
        :title="$t.enterpriseLogistics.accountName"
        show-toolbar
        :columns="categoryOptions2"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="accountConfirm($event)"
        @cancel="showAccountPicker = false"
      />
    </van-popup>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.enterpriseLogistics.handoverDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Uploader,
  Icon,
  Image,
  Popup,
  DatetimePicker,
  RadioGroup,
  Radio,
  Stepper,
  Picker,
  Collapse,
  CollapseItem,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Image)
  .use(Popup)
  .use(DatetimePicker)
  .use(RadioGroup)
  .use(Radio)
  .use(Stepper)
  .use(Picker)
  .use(Collapse)
  .use(CollapseItem);

export default {
  name: "employeeDetail",
  data() {
    return {
      EAId: "",
      form: {},
      activeNames: ["1"],
      filesIndex: 0,
      contents: {
        ReceiveServer: "", //收件服务器
        ReceivePort: "", //收件端口
        SendServer: "", //发件服务器
        SendPort: "", //	发件端口
        ResourceAllocationList: [], //分配资源列表
        //分配资源文件列表
        ResourceAllocationFileList1: [],
        ResourceAllocationFileList2: [],
        ResourceAllocationFileList3: [],
        ResourceAllocationFileList4: [],
      },
      //选项
      assetTypeOptions: [],
      categoryList: [],
      categoryOptions1: [],
      categoryOptions2: [],
      //picker
      itemIndex: 0,
      itemTable: "",
      showAssetPicker: false,
      showACPicker: false,
      showProductPicker: false,
      showAccountPicker: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showTimePicker: false,
    };
  },
  created() {
    const { EAId } = this.$route.query;
    this.EAId = EAId;
    this.getEmployeeArchivesInfoDetail();
  },
  methods: {
    showTimeDate() {
      if (!this.itemTable) {
        return;
      }
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      this.contents[this.itemTable][this.itemIndex].HandoverDate = formatDate(date);
      this.showTimePicker = false;
    },
    handleResourceDelByIndex(index) {
      if (this.contents.ResourceAllocationList.length > 0) {
        this.contents.ResourceAllocationList.splice(index, 1);
      }
    },
    handleResourceDel() {
      if (this.contents.ResourceAllocationList.length > 0) {
        this.contents.ResourceAllocationList.pop();
      }
    },
    handleResourceAdd() {
      this.contents.ResourceAllocationList.push({
        ERAName: "",
        ERAId: "",
        //1
        AssetTypeName: "",
        AssetType: "",
        //2
        ACName: "",
        ACId: "",
        //3
        ProductName: "",
        AccountNumber: "",
        AssetId: "",
        HandoverDate: this.defaultDate(),
      });
    },
    defaultDate() {
      let currentDate = new Date();
      let year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1;
      let day = currentDate.getDate();
      if (month < 10) {
        month = "0" + month;
      }

      if (day < 10) {
        day = "0" + day;
      }
      let formattedDate = year + "-" + month + "-" + day;
      return formattedDate;
    },
    pickerShow(index, pickerName, table) {
      if (this.contents[table][index].ERAId) {
        return;
      }
      this.assetTypeOptions = [
        {
          text: this.$t.employee.fixedAssets,
          value: 1,
        },
        {
          text: this.$t.employee.digitalAssets,
          value: 2,
        },
      ];
      if (pickerName == "showACPicker") {
        if (this.categoryList.length == 0) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.employee.assetNoData,
            type: "danger",
          });
          return;
        }
      }
      if (pickerName == "showProductPicker") {
        if (this.categoryOptions1.length == 0) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.employee.classNoData,
            type: "danger",
          });
          return;
        }
      }
      if (pickerName == "showAccountPicker") {
        if (this.categoryOptions2.length == 0) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.employee.classNoData,
            type: "danger",
          });
          return;
        }
      }
      this[pickerName] = true;
      this.itemIndex = index;
      if (table) this.itemTable = table;
    },
    accountConfirm(e) {
      if (!e) {
        return;
      }
      var data = this.contents[this.itemTable][this.itemIndex];
      data.AccountNumber = e.text;
      data.AssetId = e.value;
      this.showAccountPicker = false;
    },
    productConfirm(e) {
      if (!e) {
        return;
      }
      var data = this.contents[this.itemTable][this.itemIndex];
      data.ProductName = e.text;
      data.AssetId = e.value;
      this.showProductPicker = false;
    },
    acConfirm(e) {
      if (!e) {
        return;
      }
      var data = this.contents[this.itemTable][this.itemIndex];
      data.ProductName = "";
      data.AccountNumber = "";
      data.AssetId = "";
      data.ACName = e.text;
      data.ACId = e.value;
      this.showACPicker = false;
      this.getAssetInfoListByCategory(data);
    },
    assetConfirm(e) {
      var data = this.contents[this.itemTable][this.itemIndex];
      data.ACName = "";
      data.ACId = "";
      data.AssetTypeName = e.text;
      data.AssetType = e.value;
      if (data.AssetType == 1) {
        this.getAssetCategoryList(1);
      }
      if (data.AssetType == 2) {
        this.getAssetCategoryList(2);
      }
      this.showAssetPicker = false;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getAssetCategoryList(type) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.businessLogistics
          .getAssetCategoryList({
            AssetType: type,
          })
          .then((res) => {
            var categoryList = [];
            res.data.forEach((item) => {
              let data = {
                text: item.AssetName,
                value: item.ACId,
              };
              categoryList.push(data);
            });
            this.categoryList = this.$commonMethod.deepClone(categoryList);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getAssetInfoListByCategory(row) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.businessLogistics
          .getAssetInfoListByCategory({
            AssetType: row.AssetType,
            ACId: row.ACId,
          })
          .then((res) => {
            if (row.AssetType == 1) {
              var categoryOptions1 = [];
              res.data.forEach((item) => {
                let data = {
                  text: item.ProductName,
                  value: item.AssetId,
                };
                categoryOptions1.push(data);
              });
              this.categoryOptions1 = this.$commonMethod.deepClone(categoryOptions1);
            }
            if (row.AssetType == 2) {
              var categoryOptions2 = [];
              res.data.forEach((item) => {
                let data = {
                  text: item.AccountNumber,
                  value: item.AssetId,
                };
                categoryOptions2.push(data);
              });
              this.categoryOptions2 = this.$commonMethod.deepClone(categoryOptions2);
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getEmployeeArchivesInfoDetail() {
      this.$commonMethod.showLoading();
      var param = {
        EAId: this.EAId,
      };
      this.$api.businessLogistics
        .getEmployeeArchivesInfoDetail(param)
        .then((res) => {
          this.form = res.data;
          //企业分配资源
          var resource = res.data.ResourceAllocation;
          var email = res.data.ResourceAllocation.EmailSetting;

          if (email) {
            this.contents.ReceiveServer = email.ReceiveServer ? email.ReceiveServer : "";
            this.contents.ReceivePort = email.ReceivePort ? email.ReceivePort : "";
            this.contents.SendServer = email.SendServer ? email.SendServer : "";
            this.contents.SendPort = email.SendPort ? email.SendPort : "";
          }

          this.contents.ResourceAllocationList = resource.ResourceAllocationList
            ? resource.ResourceAllocationList
            : [];

          for (var item of this.contents.ResourceAllocationList) {
            item.ACName = item.AssetName;
            item.AssetTypeName =
              item.AssetType == 1
                ? this.$t.employee.fixedAssets
                : this.$t.employee.digitalAssets;
          }

          this.contents.ResourceAllocationFileList1 = resource.ResourceAllocationFileList1
            ? resource.ResourceAllocationFileList1
            : [];

          this.contents.ResourceAllocationFileList2 = resource.ResourceAllocationFileList2
            ? resource.ResourceAllocationFileList2
            : [];

          this.contents.ResourceAllocationFileList3 = resource.ResourceAllocationFileList3
            ? resource.ResourceAllocationFileList3
            : [];

          this.contents.ResourceAllocationFileList4 = resource.ResourceAllocationFileList4
            ? resource.ResourceAllocationFileList4
            : [];
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = {};
      param = this.contents;
      var filesList = [];
      filesList = filesList.concat(this.contents.ResourceAllocationFileList1);
      filesList = filesList.concat(this.contents.ResourceAllocationFileList2);
      filesList = filesList.concat(this.contents.ResourceAllocationFileList3);
      filesList = filesList.concat(this.contents.ResourceAllocationFileList4);
      param.ResourceAllocationFileList = filesList;
      param.EAId = this.EAId;
      this.$api.businessLogistics
        .saveResourceAllocationOperation(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    handleResource1DelByIndex(index) {
      if (this.contents.ResourceAllocationFileList1.length > 0) {
        this.contents.ResourceAllocationFileList1.splice(index, 1);
      }
    },
    handleResource1Del() {
      if (this.contents.ResourceAllocationFileList1.length > 0) {
        this.contents.ResourceAllocationFileList1.pop();
      }
    },
    handleResource1Add() {
      this.contents.ResourceAllocationFileList1.push({
        ResourceType: 1,
        FileAddress: "",
      });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.contents.ResourceAllocationFileList1[this.filesIndex].FileAddress =
            res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    handleResource2DelByIndex(index) {
      if (this.contents.ResourceAllocationFileList2.length > 0) {
        this.contents.ResourceAllocationFileList2.splice(index, 1);
      }
    },
    handleResource2Del() {
      if (this.contents.ResourceAllocationFileList2.length > 0) {
        this.contents.ResourceAllocationFileList2.pop();
      }
    },
    handleResource2Add() {
      this.contents.ResourceAllocationFileList2.push({
        ResourceType: 2,
        FileAddress: "",
      });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.contents.ResourceAllocationFileList2[this.filesIndex].FileAddress =
            res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    handleResource3DelByIndex(index) {
      if (this.contents.ResourceAllocationFileList3.length > 0) {
        this.contents.ResourceAllocationFileList3.splice(index, 1);
      }
    },
    handleResource3Del() {
      if (this.contents.ResourceAllocationFileList3.length > 0) {
        this.contents.ResourceAllocationFileList3.pop();
      }
    },
    handleResource3Add() {
      this.contents.ResourceAllocationFileList3.push({
        ResourceType: 3,
        FileAddress: "",
      });
    },
    afterRead3(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.contents.ResourceAllocationFileList3[this.filesIndex].FileAddress =
            res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    handleResource4DelByIndex(index) {
      if (this.contents.ResourceAllocationFileList4.length > 0) {
        this.contents.ResourceAllocationFileList4.splice(index, 1);
      }
    },
    handleResource4Del() {
      if (this.contents.ResourceAllocationFileList4.length > 0) {
        this.contents.ResourceAllocationFileList4.pop();
      }
    },
    handleResource4Add() {
      this.contents.ResourceAllocationFileList4.push({
        ResourceType: 4,
        FileAddress: "",
      });
    },
    afterRead4(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.contents.ResourceAllocationFileList4[this.filesIndex].FileAddress =
            res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.employeeDetail {
  .avatarImg {
    width: 80px;
    height: 80px;
    .userImg {
      width: 80px;
      height: 80px;
      object-fit: contain;
      border-radius: 100%;
    }
    ::v-deep .van-image__error {
      border-radius: 100%;
      position: block;
    }
    ::v-deep .van-image__img {
      object-fit: contain;
      border-radius: 100px;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-collapse-item__content {
    padding: 0px 15px 15px 15px;
    background: transparent;
    border-top: 1px solid #ebedf0;
  }
  ::v-deep .van-collapse {
    border-bottom: 1px solid #ebedf0;
  }
  ::v-deep .van-collapse::after {
    border: none !important;
  }
  ::v-deep .van-collapse-item__title--expanded::after {
    display: none !important;
  }
  ::v-deep .van-switch--disabled {
    opacity: 1 !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .custom-date {
    padding: 10px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 80px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
}
</style>
